import { PackagingTable } from '../components/packaging/PackagingTableV2';
import { PackagingModal, MODAL_KEY } from '../components/packaging/PackagingModalV2';
import { useStoreActions, useStoreState } from '../store';
import { PlusCircleOutlined, DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Card, Space, Tabs, Upload } from 'antd';
import { useEffect, useMemo } from 'react';
import { PackagingSetsTable } from '../components/packaging/PackagingSetsTable';
import { PACKAGING_SET_MODAL_KEY, PackagingSetModal } from '../components/packaging/PackagingSetModal';
import { useSearchParams } from 'react-router-dom-v5-compat';
import type { PackagingType } from '../store/services/PartnerService/types';
import { EditPackagingSetModal } from '../components/packaging/EditPackagingSetModal';
export const PackagingConfiguration = () => {
  const toggleModal = useStoreActions((action) => action.navigation.toggleModal);
  const canEdit = useStoreState((state) => state.session.canEdit);
  const loading = useStoreState((state) => state.loading.pageLoading);
  const fetchPackaging = useStoreActions((action) => action.packagingV2.fetchPartnerPackagingV2);
  const fetchPackagingSets = useStoreActions((action) => action.packagingV2.fetchPackagingSets);
  const [query, setQuery] = useSearchParams();

  const openModal = () => {
    toggleModal({ open: true, key: MODAL_KEY, params: undefined });
  };

  const openPackagingSetModal = () => {
    toggleModal({ open: true, key: PACKAGING_SET_MODAL_KEY, params: undefined });
  };

  const parsedParams = useMemo(() => {
    const queryTab = query.get('tab');
    const tab = (queryTab ?? 'packaging') as PackagingType;
    return {
      activeTab: tab,
    };
  }, [query]);

  const { activeTab } = parsedParams;

  // Refetch whenever a tab is opened: deleting (archiving) in Fulfillment Configuration doesn't update this store
  // slice. This lives here, not in the tables, because the tables sit inside <Card loading>, which unmounts them
  // while a fetch is in flight; fetching on table mount would loop.
  useEffect(() => {
    fetchPackaging();
    if (activeTab === 'packagingSets') {
      fetchPackagingSets();
    }
  }, [activeTab, fetchPackaging, fetchPackagingSets]);

  const upload = (
    <Upload accept=".csv" beforeUpload={() => false} multiple={false} showUploadList={false}>
      <Button disabled>
        <UploadOutlined /> Upload Packaging CSV Data
      </Button>
    </Upload>
  );
  return (
    <Card>
      <Tabs
        onTabClick={(val) => {
          query.set('tab', val);
          setQuery(query);
        }}
        type={'card'}
        activeKey={activeTab}
        items={[
          { key: 'packaging', label: 'Packaging' },
          { key: 'packagingSets', label: 'Packaging Sets' },
        ]}
      />
      {activeTab === 'packaging' && (
        <Card loading={loading} title={'Configured Packaging'}>
          <Space style={{ marginBottom: 16 }}>
            {upload}
            <Button icon={<DownloadOutlined />} disabled>
              Download Packaging Template
            </Button>
            {canEdit && (
              <Button onClick={openModal} icon={<PlusCircleOutlined />}>
                Add New Packaging
              </Button>
            )}
          </Space>
          <PackagingTable />
          <PackagingModal />
        </Card>
      )}
      {activeTab === 'packagingSets' && (
        <Card loading={loading} title={'Configured Packaging Sets'}>
          <div style={{ marginBottom: 16 }}>
            {canEdit && (
              <Button onClick={openPackagingSetModal} icon={<PlusCircleOutlined />}>
                Add New Packaging Set
              </Button>
            )}
          </div>
          <PackagingSetsTable />
          <PackagingSetModal />
          <EditPackagingSetModal />
        </Card>
      )}
    </Card>
  );
};

export default PackagingConfiguration;
